import { render } from "./frameworks.vue?vue&type=template&id=32a7028c&scoped=true&ts=true"
import script from "./frameworks.vue?vue&type=script&lang=ts"
export * from "./frameworks.vue?vue&type=script&lang=ts"

import "./frameworks.vue?vue&type=style&index=0&id=32a7028c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a7028c"]])

export default __exports__